module.exports = __webpack_public_path__ + "static/media/SN.3217a380.wav";